export default __webpack_public_path__ + "static/media/E-WEB-Goal-17.f970e7c3.png";